import { Grid, Typography } from '@mui/material';
import { MediaUpload, RHFTextField } from 'components';
import { useInspectionPath } from 'hooks';
import { useInspectionSelector } from 'stores';

// Punto 26 issue #1021, riaperto 2026-09-04 ("devo poter richiamare le
// foto, non ho più il pulsante") — le immagini non sono un punto di
// caricamento ma di RICHIAMO da quelle già presenti sull'ispezione: stesso
// pattern già in uso in "10. Commenti per report" di L0
// (Accordion11CommentiPerReport.jsx), `onlySelection` su MediaUpload
// (DrawerMediaSelectedTable, non DrawerMediaTable) mostra un bottone
// "Seleziona" che pesca dal pool di useImagesSelector — popolato per
// l'attività CORRENTE da useInspection.js (GET medias/inspections/:id/images)
// — mai un vero upload. Alla creazione di un'attività L3,
// MediaExtensions.normalizeMedias (BE) ri-intesta già le immagini ereditate
// da Contesto/Idraulica dell'ultima L0,1,2 su questa stessa attività, quindi
// rientrano in quel pool senza bisogno di leggere diagnosis.L0/L1 a parte.
//
// Stile — riallineato allo stesso layout di L0/L1 (screenshot cliente,
// 2026-09-22): descrizione a tutta larghezza, box "Immagini" (titolo
// generico, non per-sezione) su una riga propria sotto, niente più
// `compact`/side-by-side xs=9/xs=3. NON riuso GridWrap/TitleSection di
// Accordion11CommentiPerReport.styles.js: margini negativi tarati per il
// contenitore accordion di L0, già visti rompere il layout altrove in
// questo stesso file L3 (vedi Accordion1GeneralInfoL3.jsx, punto 17) — qui
// stesso pattern "positivo" già in uso nel resto degli accordion L3.
// Titoletti sezione in blu/bold/stampatello (`h3BoldBlue`, stesso variant di
// L0/L1) al posto del `subtitle1` grigio/regular precedente, senza più il
// prefisso numerico ("3.1 " ecc.) — stessa convenzione di L0/L1, dove i
// titoli sono nomi nudi in maiuscolo ("DESCRIZIONE DELL'OPERA" ecc.).
const infoPanel =
  "Seleziona le foto tra quelle già presenti sull'attività, ereditate dall'ultima attività L0,1,2";

const Accordion6ReportCommentsL3 = () => {
  // e-2026-06-t21 — stesso pattern di L0/L1, vedi Accordion1GeneralInfoL3.jsx.
  const { inspectionDisabled } = useInspectionSelector();
  const { isViewingInspection } = useInspectionPath();
  const readOnly = inspectionDisabled || isViewingInspection;

  return (
    <Grid container spacing={2} padding="20px">
      <Grid item xs={12}>
        <Typography variant="h3BoldBlue">
          INQUADRAMENTO TERRITORIALE
        </Typography>
      </Grid>
      <Grid item xs={12}>
        <RHFTextField
          name="inquadramentoTerritorialeDescrizione"
          label={'Descrizione'}
          multiline
          minRows={3}
          defaultValue=""
          disabled={readOnly}
        />
      </Grid>
      <Grid item md={3}>
        <MediaUpload
          title={'Immagini'}
          btnTitle="Seleziona"
          preview={true}
          formName="inquadramentoTerritorialeImmagini"
          infoPanel={infoPanel}
          onlySelection={true}
        />
      </Grid>

      <Grid item xs={12}>
        <Typography variant="h3BoldBlue">
          DOCUMENTAZIONE DISPONIBILE
        </Typography>
      </Grid>
      <Grid item xs={12}>
        <RHFTextField
          name="documentazioneDisponibileDescrizione"
          label={'Descrizione'}
          multiline
          minRows={3}
          defaultValue=""
          disabled={readOnly}
        />
      </Grid>
      <Grid item md={3}>
        <MediaUpload
          title={'Immagini'}
          btnTitle="Seleziona"
          preview={true}
          formName="documentazioneDisponibileImmagini"
          infoPanel={infoPanel}
          onlySelection={true}
        />
      </Grid>

      <Grid item xs={12}>
        <Typography variant="h3BoldBlue">
          DESCRIZIONE DELLA STRUTTURA
        </Typography>
      </Grid>
      <Grid item xs={12}>
        <RHFTextField
          name="descrizioneStrutturaDescrizione"
          label={'Descrizione'}
          multiline
          minRows={3}
          defaultValue=""
          disabled={readOnly}
        />
      </Grid>
      <Grid item md={3}>
        <MediaUpload
          title={'Immagini'}
          btnTitle="Seleziona"
          preview={true}
          formName="descrizioneStrutturaImmagini"
          infoPanel={infoPanel}
          onlySelection={true}
        />
      </Grid>

      <Grid item xs={12}>
        <Typography variant="h3BoldBlue">
          CARATTERIZZAZIONE DEL SISTEMA
        </Typography>
      </Grid>
      <Grid item xs={12}>
        <RHFTextField
          name="caratterizzazioneSistemaDescrizione"
          label={'Descrizione'}
          multiline
          minRows={3}
          defaultValue=""
          disabled={readOnly}
        />
      </Grid>
      <Grid item md={3}>
        <MediaUpload
          title={'Immagini'}
          btnTitle="Seleziona"
          preview={true}
          formName="caratterizzazioneSistemaImmagini"
          infoPanel={infoPanel}
          onlySelection={true}
        />
      </Grid>

      <Grid item xs={12}>
        <Typography variant="h3BoldBlue">
          SCENARI IDRAULICI DI RIFERIMENTO
        </Typography>
      </Grid>
      <Grid item xs={12}>
        <RHFTextField
          name="scenariIdrauliciRiferimentoDescrizione"
          label={'Descrizione'}
          multiline
          minRows={3}
          defaultValue=""
          disabled={readOnly}
        />
      </Grid>
      <Grid item md={3}>
        <MediaUpload
          title={'Immagini'}
          btnTitle="Seleziona"
          preview={true}
          formName="scenariIdrauliciRiferimentoImmagini"
          infoPanel={infoPanel}
          onlySelection={true}
        />
      </Grid>

      <Grid item xs={12}>
        <Typography variant="h3BoldBlue">
          VALUTAZIONE DEL RISCHIO DI SORMONTO
        </Typography>
      </Grid>
      <Grid item xs={12}>
        <RHFTextField
          name="valutazioneRischioSormontoFrancoIdraulico"
          label={'Franco idraulico'}
          multiline
          minRows={3}
          defaultValue=""
          disabled={readOnly}
        />
      </Grid>
      <Grid item md={3}>
        <MediaUpload
          title={'Immagini'}
          btnTitle="Seleziona"
          preview={true}
          formName="valutazioneRischioSormontoImmagini"
          infoPanel={infoPanel}
          onlySelection={true}
        />
      </Grid>

      <Grid item xs={12}>
        <Typography variant="h3BoldBlue">
          VALUTAZIONE DEI FENOMENI EROSIVI
        </Typography>
      </Grid>
      <Grid item xs={12}>
        <RHFTextField
          name="valutazioneFenomeniErosiviTesto"
          label={'Fenomeni erosivi'}
          multiline
          minRows={3}
          defaultValue=""
          disabled={readOnly}
        />
      </Grid>
      <Grid item md={3}>
        <MediaUpload
          title={'Immagini'}
          btnTitle="Seleziona"
          preview={true}
          formName="valutazioneFenomeniErosiviImmagini"
          infoPanel={infoPanel}
          onlySelection={true}
        />
      </Grid>

      <Grid item xs={12}>
        <Typography variant="h3BoldBlue">CONCLUSIONI</Typography>
      </Grid>
      <Grid item xs={12}>
        <RHFTextField
          name="conclusioniDescrizione"
          label={'Descrizione'}
          multiline
          minRows={3}
          defaultValue=""
          disabled={readOnly}
        />
      </Grid>
    </Grid>
  );
};

export { Accordion6ReportCommentsL3 };
